import { Outlet } from "react-router";

export function CustomersRoute() {
  return <Outlet />;
}
